module.exports = __webpack_public_path__ + "img/wechat-banner.12d634bc.jpg";